// extracted by mini-css-extract-plugin
module.exports = {"locationLink":"Map_locationLink__5iRt_"};